import { Injectable } from '@angular/core';
import {SplashScreenComponent} from "./splash-screen.component";

@Injectable({ providedIn: 'root' })
export class SplashScreenService {
  private splashScreen: SplashScreenComponent;
  private currentVisibility = false;
  public constructor() {
  }
  set(splashScreen: SplashScreenComponent) {
    this.splashScreen = splashScreen;
    this.splashScreen.setVisible(this.currentVisibility);
  }

  public setVisible(v: boolean) {
    if(this.splashScreen && !this.splashScreen.invisible) {
      this.splashScreen.setVisible(v);
    }
    this.currentVisibility = v;
  }
}
